import {Component, Input} from '@angular/core';
import { IBasicChart } from 'app/rpa-bots/uipath/common/models/IBasicChart';
import {Chart} from 'chart.js';


@Component({
  selector: 'bz-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})


export class PieChartComponent {

  @Input() dataChart: IBasicChart[];
  @Input() title: string;
  @Input() idChart: string;

  player = [];
  run = [];
  chart: any;

  @Input() tabIndex: number;
  @Input() myIndex: number;

  constructor() {
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  refresh() {
    if (!this.dataChart) {
      return;
    }

    this.player = [];
    this.run = [];

    if (this.chart) {
      this.chart.destroy();
    }
    this.dataChart.forEach(x => {
      this.player.push(x.letter);
      this.run.push(x.frequency);
    })
    const canvasChart = document.getElementById(this.idChart) as HTMLCanvasElement;
    if (!canvasChart) {
      return;
    }

    const ctx = canvasChart.getContext('2d');
    this.chart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: this.player,
        datasets: [
          {
            data: this.run,
            // borderColor: '#dddddd',
            backgroundColor: [
              '#E0E0E0',
              '#DB8181',
              '#BDE17A',
              '#FFE172',
              '#7EDBDD',
              '#FFBE85',
              '#E6F4CD'
            ],
            fill: true
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: this.title,
          // position: 'left',
          fontSize: 20,
          fontColor: '#272727',
          padding: 5,
          fontFamily: '\'Open Sans\', Verdana, Serif',
          fontStyle: 'italic'
        },
        animation: {
          animateRotate: true
        },
        legend: {
          display: true,
          position: 'bottom',
          fullWidth: true,
          labels: {
            fontSize: 12,
            fontFamily: '\'Open Sans\', Verdana, Serif',
            fontStyle: 'italic'
          }
        },
        scales: {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: false
          }],
        }
      }
    });
  }
}
